import { BaseService, Unauthorized, UnexpectedError } from './base-service';

class PolygonService extends BaseService {

    async getPolygonsType(companyId?: number): Promise<{ type: string; }[]> {
        const token = await this.getToken();

        const res = await fetch(`${this.centralEndpoint}/map-polygon-types${this.encodeQueryParams({ companyId })}`, {
            method: 'GET',
            headers: this.getHeaders(token, 'application/json;charset=utf-8'),
        });

        if (res.status == 401) {
            throw new Unauthorized();
        }

        if (res.status == 204) {
            return [];
        }

        if (res.status != 200) {
            throw new UnexpectedError();
        }

        return res.json();
    }

    async getPolygonsByType(type: string, companyId?: number): Promise<MapPolygon[]> {
        const token = await this.getToken();

        const res = await fetch(`${this.centralEndpoint}/map-polygon/${type}${this.encodeQueryParams({ companyId })}`, {
            method: 'GET',
            headers: this.getHeaders(token, 'application/json;charset=utf-8'),
        });

        if (res.status == 401) {
            throw new Unauthorized();
        }

        if (res.status == 204) {
            return [];
        }

        if (res.status != 200) {
            throw new UnexpectedError();
        }

        return res.json();
    }
}

export const polygonService = new PolygonService();
